<template>
  <modal
    name="unavailableFavoriteItemModal"
    :display-header-title="false"
  >
    <unavailable-favorite-item />
  </modal>
</template>


<script>
  import UnavailableFavoriteItem from './unavailable-favorite-item/index.vue';


  export default {
    name: 'UnavailableFavoriteItemModal',

    components: {
      UnavailableFavoriteItem
    }
  };
</script>
